export class MinMaxAge {
  min: number
  max: number

  constructor(data: any = {}) {
    this.min = Number(data.min)
    this.max = Number(data.max)
  }
}
